import React from 'react'
import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import Button from '_app/components/Buttons/Button'

interface MobileActionsProps {
  onClear: () => void;
  onSubmit?: () => void;
  formId?: string;
  count?: React.ReactNode;
  loadingState?: 'clear' | 'submit';
}

const MobileActions = ({
  onClear,
  onSubmit,
  formId,
  count,
  loadingState,
}: MobileActionsProps) => {
  const { t } = useTranslation()

  return (
    <Flex
      py={4}
      px={4}
      bg="white"
      boxShadow="0 -5px 8px 0 rgba(83, 56, 24, 0.09)"
    >
      <Button
        flex={1}
        minWidth="unset"
        reversed
        onClick={onClear}
        isLoading={loadingState === 'clear'}
      >
        {t('CLEAR')}
      </Button>
      <Button
        flex={1}
        minWidth="unset"
        type={formId ? 'submit' : 'button'}
        onClick={onSubmit}
        form={formId}
        isLoading={loadingState === 'submit'}
      >
        {t('APPLY', { ns: 'common' })}
        {count}
      </Button>
    </Flex>
  )
}

export default MobileActions
